import "@lit-labs/ssr-client/lit-element-hydrate-support.js";
import * as React from "react";
import * as ReactDOM from "react-dom/client";
import * as Scrivito from "scrivito";
import "./Objs/index.js";
import "./Widgets/index.js";
import { App } from "./App.js";
import configure from "./config/index.js";

configure();

if (window.preloadDump) {
  Scrivito.preload(window.preloadDump).then(({ dumpLoaded }) => {
    delete window.preloadDump;
    dumpLoaded ? hydrateApp() : renderApp();
  });
} else {
  renderApp();
}

function renderApp() {
  ReactDOM.createRoot(document.getElementById("root")).render(<App />);
}

function hydrateApp() {
  ReactDOM.hydrateRoot(
    document.getElementById("root"),
    <App
      appWrapperRef={(el) => {
        if (el) {
          Scrivito.updateContent();
        }
      }}
    />
  );
}

if (Scrivito.isEditorLoggedIn()) {
  import("./Objs/editingConfigs");
  import("./Widgets/editingConfigs");
}
